import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CashpaymentService } from '../../../../../core';
import { PopupMessageService } from '../../../../../shared/message/services/message.service';

@Component({
  selector: 'app-confirm-payment-modal',
  templateUrl: './confirm-payment-modal.component.html',
  styleUrls: ['./confirm-payment-modal.component.scss']
})
export class ConfirmPaymentModalComponent implements OnChanges {
  @Input() isOpen: boolean = false;
  @Input() companyId: any;
  @Input() cashPaymentId: any;

  @Output() close = new EventEmitter<void>();
  @Output() paymentConfirmed = new EventEmitter<void>();

  paymentSignature: string = '';

  constructor(
    private cashPaymentService: CashpaymentService,
    private popupMessageService: PopupMessageService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'] && this.isOpen) {
      this.paymentSignature = '';
    }
  }

  confirm(): void {
    if (!this.paymentSignature || this.paymentSignature.trim() === '') {
      return;
    }
    const req = {
      companyId: this.companyId,
      cashPaymentId: this.cashPaymentId,
      proofOfPaymentSignature: this.paymentSignature,
    };
    this.cashPaymentService.submitProofOfPayment(req).subscribe(
      (response: any) => {
        if (response) {
          this.popupMessageService.showSuccess(response.msg, 'success');
          this.paymentConfirmed.emit();
        }
      },
      (error: any) => {
        if (error.message) {
          this.popupMessageService.showError(error.message, 'error');
        }
      }
    );
  }
}
